import './BSuggestionChips.css';

interface BSuggestionChipsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
}

/**
 * Clickable suggestion chips that fill the search input.
 */
export function BSuggestionChips({ suggestions, onSelect }: BSuggestionChipsProps) {
  return (
    <div className="b-suggestions">
      {suggestions.map((suggestion, index) => (
        <span key={index}>
          <button
            className="b-suggestion-chip"
            onClick={() => onSelect(suggestion)}
            type="button"
          >
            {suggestion}
          </button>
          {index < suggestions.length - 1 && ' · '}
        </span>
      ))}
    </div>
  );
}
